import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface TextFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function TextField({ field, value, onChange, readOnly, error }: TextFieldProps) {
  return (
    <FieldWrapper field={field} error={error}>
      <input
        type="text"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder}
        readOnly={readOnly}
        className="w-full px-2 py-1.5 text-sm border rounded outline-none focus:ring-1 focus:ring-blue-500"
        style={{
          backgroundColor: 'var(--color-bg-input, var(--color-bg-card))',
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-primary)',
        }}
      />
    </FieldWrapper>
  )
}
